import { Container, Row, Col } from 'react-bootstrap';
import { PersonBoundingBox, Sliders, CashCoin } from 'react-bootstrap-icons';
import ScrollAnimation from 'react-animate-on-scroll';

const steps = [
  {
    icon: PersonBoundingBox,
    number: '01',
    title: 'Select Your Injuries',
    description: 'Click on our interactive 3D body model to identify up to 4 injured areas. Front or back — we\'ve got you covered.',
  },
  {
    icon: Sliders,
    number: '02',
    title: 'Rate Severity',
    description: 'Use our simple slider to rate how severe each injury is on a scale of 1-10. Accurate ratings lead to better estimates.',
  },
  {
    icon: CashCoin,
    number: '03',
    title: 'Get Your Estimate',
    description: 'Instantly see what your claim could be worth — both with and without attorney representation.',
  },
];

export function HowItWorks() {
  return (
    <section className="qmi-how-it-works qmi-section" id="how-it-works">
      <Container>
        <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
          <div className="text-center mb-5">
            <span className="qmi-section-label">Simple Process</span>
            <h2 className="qmi-title racing-sans-one-regular">
              How It Works
            </h2>
            <p className="qmi-subtitle mx-auto">
              Get your injury estimate in three easy steps. No sign-up required.
            </p>
          </div>
        </ScrollAnimation>

        <Row className="qmi-steps-row">
          {steps.map((step, index) => (
            <Col md={4} key={step.number} className="mb-4 mb-md-0">
              <ScrollAnimation
                animateIn="fadeInUp"
                animateOnce={true}
                delay={index * 150}
              >
                <div className="qmi-step-card">
                  {/* Connector line */}
                  {index < steps.length - 1 && (
                    <div className="qmi-step-connector-line hide-mobile"></div>
                  )}

                  {/* Step number badge */}
                  <div className="qmi-step-number">{step.number}</div>

                  {/* Icon */}
                  <div className="qmi-step-icon">
                    <step.icon size={32} />
                  </div>

                  {/* Content */}
                  <h3 className="qmi-step-title">{step.title}</h3>
                  <p className="qmi-step-description">{step.description}</p>
                </div>
              </ScrollAnimation>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
